import { createAsyncSelectors } from '@lib/selectors';
import { getClosestPopup } from '@lib/popups';
import { getInitiativeJiraIssuesSelector } from '../../@arch/selectors';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { JiraIssue } from './JiraIssue';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useAction, useCurrentUser, useJiraStatuses, useSonarSelector } from '@hooks';
const getJiraIssuesSelectors = createAsyncSelectors((state) => state.integrations.jira.issues.get);
export const JiraIssuesPopover = ({ initiativeId }) => {
    const [query, setQuery] = useState();
    useJiraStatuses();
    const getJiraIssues = useAction(integrationsActions.requestGetJiraIssues);
    const putJiraInitiativesLink = useAction(integrationsActions.requestPutJiraInitiativesLinkIssue);
    const resetJiraIssues = useAction(integrationsActions.resetGetJiraIssues);
    const jiraIssuesData = useSonarSelector(getJiraIssuesSelectors.data);
    const initiativeJiraIssues = useSonarSelector(getInitiativeJiraIssuesSelector.data);
    const jiraIssuesRequested = useSonarSelector(getJiraIssuesSelectors.isRequested);
    const selectRef = useRef(null);
    const { customerId } = useCurrentUser();
    useEffect(() => {
        var _a;
        (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [selectRef]);
    const handleOnClear = useCallback(() => {
        setQuery(undefined);
        resetJiraIssues();
    }, [resetJiraIssues]);
    const handleOnSearch = useCallback((value) => {
        setQuery(value || undefined);
        if ((value === null || value === void 0 ? void 0 : value.length) >= 3) {
            getJiraIssues({ searchText: value });
        }
        else {
            resetJiraIssues();
        }
    }, [getJiraIssues, resetJiraIssues]);
    const options = useMemo(() => {
        const jiraIssueOptions = [];
        jiraIssuesData === null || jiraIssuesData === void 0 ? void 0 : jiraIssuesData.forEach((issue) => {
            const { issueKey, issueName, statusId, projectKey } = issue;
            if (!(initiativeJiraIssues === null || initiativeJiraIssues === void 0 ? void 0 : initiativeJiraIssues.some((jiraIssue) => jiraIssue.issueKey === issueKey))) {
                jiraIssueOptions.push({
                    label: React.createElement(JiraIssue, { initiativeId: initiativeId, issueKey: issueKey, issueName: issueName, projectKey: projectKey, statusId: statusId }),
                    value: issueKey
                });
            }
        });
        return jiraIssueOptions;
    }, [initiativeId, initiativeJiraIssues, jiraIssuesData]);
    const handleOnSelect = (selected) => {
        const jiraIssue = jiraIssuesData === null || jiraIssuesData === void 0 ? void 0 : jiraIssuesData.filter((jiraStatus) => jiraStatus.issueKey === selected);
        if (jiraIssue) {
            const [{ issueKey, issueName, statusId, projectKey }] = jiraIssue;
            putJiraInitiativesLink({
                customerId: customerId,
                initiativeId: initiativeId,
                issueKey: issueKey,
                issueName: issueName,
                projectKey: projectKey,
                statusId: statusId
            });
        }
    };
    return (React.createElement("div", { id: 'ant-popover' },
        React.createElement(Select, { allowClear: true, className: 'jira-issue-select', filterOption: false, getPopupContainer: getClosestPopup, notFoundContent: jiraIssuesRequested ? React.createElement(LoadingSpinner, null) : null, onClear: handleOnClear, onSearch: handleOnSearch, onSelect: handleOnSelect, options: options, placeholder: PLACEHOLDERS_COPY.SEARCH_JIRA_ISSUES, ref: selectRef, showSearch: true, value: query })));
};
